exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "li[data-v-da455e3c]{list-style-type:none}#app[data-v-da455e3c]{font-family:Helvetica,sans-serif;text-align:center}#app #page-header .all_goods[data-v-da455e3c]{width:1920px;height:740px;background-image:url(" + require("../../assets/images/shop_bg01.jpg") + ");background-repeat:no-repeat}#app #page-header .part_title[data-v-da455e3c]{padding:50px 0;font-size:36px;font-weight:500;color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da455e3c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/home/index.vue
// module id = 165
// module chunks = 1